import { SimpleLogin, loginConfig, ErrorCodesType } from '@tencent/wphk-act-base-api';
import { initRequestBlockInterceptors } from './request-block-interceptors';
import { HandleLoginOptions, HandleLoginParams } from '../types/index';
import { request } from '@tencent/ppd-base-libs';
import { LoginReport } from '@tencent/wphk-base-report';
import { cacheFunc, to } from '@tencent/wphk-base-utils';

/**
 * 营销登陆处理
 * @param options 登陆处理相关选项
 */
export function handlePromLogin(options: HandleLoginOptions) {
  const { beforeLogin, errCodes, business, loginConfig: loginConf } = options;
  const simpleLogin = new SimpleLogin(request, loginConf);
  // 缓存登陆请求，防止多个接口并行请求，导致调用多次登陆
  const cacheTokenLogin = cacheFunc(() => simpleLogin.tokenLogin());
  /**
   * CGI登录状态检测 + 自动登录
   * 自动检测登陆态、并实现自动登陆，同时拦截登陆超时后的请求
   */
  initRequestBlockInterceptors({
    blockingRequest: {
      errCodes,
      /** 登陆前的处理 */
      beforeLogin(loginOptions: HandleLoginParams) {
        const { isLoggedIn } = loginOptions;
        // 执行登陆操作前的处理，如关闭loading等，没有的话可不处理
        if (beforeLogin) {
          beforeLogin(loginOptions);
        }
        if (!isLoggedIn) {
          try {
            const loginReport = new LoginReport(business);
            loginReport.reportStartTiming();
          } catch (error) {
          }
        }
      },
      /** 微信授权获取code */
      getOAuthCode() {
        // 进行微信Auth登陆获取code
        simpleLogin.getWXOAuthCodeByJumpToWx({
          url: location.href,
        });
      },
      /** 检测到登陆态已失效，尝试使用token预登陆 */
      async preLogin(config, isLoggedIn) {
        // 预登陆检测到登陆态失效，说明预登陆已经失败了
        if (config.url === loginConfig.LoginSimpleApi) {
          return false;
        }
        if (isLoggedIn) {
          // 页面登陆成功后，需要清除token预登陆缓存信息
          cacheTokenLogin.clearCache();
        }
        const [err] = await to(cacheTokenLogin());
        return !err;
      },
      /** 进行auth2登陆 */
      async login(config) {
        // 登录接口直接放行
        if (config.url === loginConfig.LoginSimpleApi) {
          return;
        }
        // 登录promise函数处理
        await simpleLogin.waitLoginPromiseHandle();
      },
    },
  });
}

export  {
  ErrorCodesType,
};
